import { useMutation, useQueryClient } from '@tanstack/react-query';
import bankAccountsApi from '@/features/dashboard/paymentConfig/api/bankAccountsApi.ts';
import { bankAccountsApiQueryKeys } from '@/features/dashboard/paymentConfig/api/bankAccountsApi.queryKeys.ts';
import { CreateBankAccountFormData } from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import { bankAccountMapper } from '@/features/dashboard/paymentConfig/types/BankAccountDto.mapper.ts';
import { toast } from 'sonner';

export default function useCreateBankAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateBankAccountFormData) =>
      bankAccountsApi.create(bankAccountMapper.fromCreateFormToDto(data)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bankAccountsApiQueryKeys.all(),
      });
      toast.success('Konto bankowe zostało dodane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas dodawania konta bankowego.',
      });
    },
  });
}
